// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"409":"f97da9c2","453":"05ed978e","586":"f18af546"}[chunkId] + ".chunk.js";
};